import { render } from "./IndexCoupon.vue?vue&type=template&id=10d533a8&scoped=true"
import script from "./IndexCoupon.vue?vue&type=script&lang=js"
export * from "./IndexCoupon.vue?vue&type=script&lang=js"

import "./IndexCoupon.vue?vue&type=style&index=0&id=10d533a8&lang=scss&scoped=true"

import exportComponent from "/Users/user/workspace/okshop-diner/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d533a8"]])

export default __exports__